export const PHONE_TYPE_MAP = {
  727530000: "Home Contact Number",
  727530001: "Alternative Contact Number",
  727530002: "Work Contact Number",
  727530003: "Mobile Number",
};
